import React, { useEffect } from 'react'
import { SubmissionError } from 'redux-form'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'

import {
  fetchView,
  getView,
  updateView,
  deleteView,
} from '../../../../ducks/views'

import { fetchDatabases, getDatabases } from '../../../../ducks/databases'
import Header from '../../../Shared/Header'
import Card from '../../../Shared/Card'
import Button from '../../../Shared/Button'
import { FullScreenLoader } from '../../../Shared/Loading'
import Form from '../New/Form'

import styles from './Edit.module.css'

export default function EditView({ match }) {
  const { viewId } = match.params
  const dispatch = useDispatch()
  const history = useHistory()
  const view = useSelector(getView(viewId))
  const databases = useSelector(getDatabases(view && view.OrganizationId))

  useEffect(() => {
    dispatch(fetchView(viewId))
  }, [viewId, dispatch])

  useEffect(() => {
    if (view) {
      dispatch(fetchDatabases(view.OrganizationId))
    }
  }, [view, dispatch])

  const goBack = () => {
    history.push(`/databases/views/${viewId}`)
  }

  const handleSubmit = async values => {
    const { name, body } = values

    const data = {
      type: 'database',
      name,
      body,
    }

    try {
      await dispatch(updateView(viewId, data))

      goBack()
    } catch (err) {
      throw new SubmissionError({
        _error: 'An unknown error occurred',
      })
    }
  }

  const handleDelete = async () => {
    if (!window.confirm(`Are you sure you want to delete ${view.name}?`)) {
      return
    }

    await dispatch(deleteView(viewId))

    history.push('/databases')
  }

  if (!view || databases.length === 0) {
    return <FullScreenLoader />
  }

  return (
    <>
      <Header>Edit View: {view.name}</Header>
      <Form
        isEdit
        onSubmit={handleSubmit}
        initialValues={view}
        databases={databases}
        onCancel={goBack}
        onDelete={handleDelete}
      />
      <Card>
        <h2>Delete View</h2>
        <div className={styles.deleteButton}>
          <Button color="grey" onClick={handleDelete}>
            Delete {view.name}
          </Button>
        </div>
      </Card>
    </>
  )
}
